import { DATA_PATHS, SITE_INFO } from '@lib/constants';

const HeroSection = () => {
  return (
    <section className="relative overflow-hidden py-20 sm:py-24 lg:py-32 px-4 sm:px-6 lg:px-8">
      {/* Subtle gradient background */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(to bottom right, var(--color-theme-1), var(--color-theme-2))'
        }}
      >
        {/* Subtle ambient shapes */}
        <div
          className="absolute top-0 -left-4 w-96 h-96 rounded-full mix-blend-multiply filter blur-3xl opacity-20"
          style={{ backgroundColor: 'var(--color-accent-2)' }}
        ></div>
        <div
          className="absolute -bottom-8 right-0 w-96 h-96 rounded-full mix-blend-multiply filter blur-3xl opacity-10"
          style={{ backgroundColor: 'var(--color-accent-3)' }}
        ></div>
      </div>

      <div className="container mx-auto relative z-10 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Profile Picture */}
          <div className="flex justify-center order-2 md:order-1">
            <div className="relative">
              <div
                className="relative rounded-2xl p-1.5 shadow-card-hover"
                style={{
                  backgroundColor: 'var(--color-card-bg)',
                  borderColor: 'var(--color-border-light)',
                  borderWidth: '1px',
                  borderStyle: 'solid'
                }}
              >
                <img
                  src={DATA_PATHS.PROFILE_PICTURE}
                  alt={SITE_INFO.name}
                  className="relative w-80 h-80 rounded-xl object-cover"
                />
              </div>
            </div>
          </div>

          {/* Hero Content */}
          <div className="text-left order-1 md:order-2 space-y-4 sm:space-y-6">
            <div className="space-y-3 sm:space-y-4">
              <h1
                className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold tracking-tight"
                style={{ color: 'var(--color-heading)' }}
              >
                About Me
              </h1>
              <p
                className="text-lg sm:text-xl md:text-2xl font-semibold"
                style={{ color: 'var(--color-subheading)' }}
              >
                Welcome to my journey
              </p>
            </div>

            <p
              className="text-base sm:text-lg leading-relaxed"
              style={{ color: 'var(--color-subtle)' }}
            >
              I'm {SITE_INFO.name}, a passionate student-athlete from {SITE_INFO.location},
              dedicated to excellence in chess, robotics, and creating meaningful social impact.
              My journey is defined by strategic thinking, innovative problem-solving, and a
              commitment to giving back to my community.
            </p>

            <div className="pt-2 sm:pt-4">
              <div className="grid grid-cols-2 gap-3 sm:gap-4">
                <div>
                  <p className="text-xs sm:text-sm font-medium" style={{ color: 'var(--color-muted)' }}>
                    Location
                  </p>
                  <p className="text-sm sm:text-base font-semibold mt-1" style={{ color: 'var(--color-heading)' }}>
                    {SITE_INFO.location}
                  </p>
                </div>
                <div>
                  <p className="text-xs sm:text-sm font-medium" style={{ color: 'var(--color-muted)' }}>
                    Focus Areas
                  </p>
                  <p className="text-sm sm:text-base font-semibold mt-1" style={{ color: 'var(--color-heading)' }}>
                    Chess, Robotics, Impact
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
